import React from 'react';
import {gql} from '@apollo/client';
import {useLazyQuery} from '@apollo/client/react';
import {FileDownload} from '@mui/icons-material';
import {toast} from 'react-toastify';

import {Button} from 'components/forms/Buttons';
import {useListContext} from 'components/list/ListContext';
import {useRecordContext} from 'components/record/useRecordContext';

const EXPORT_SUBEVENTS_IOF_XML = gql`
  query ExportSubEventsIofXml($slug: String!, $ids: [Int!]!) {
    exportSubEventsIofXml(slug: $slug, ids: $ids)
  }
`;

const downloadXml = (xml: string, filename: string) => {
  const link = document.createElement('a');
  const blob = new Blob([xml], {type: 'application/xml;charset=utf-8'});
  const url = URL.createObjectURL(blob);
  link.href = url;
  link.download = filename.endsWith('.xml') ? filename : `${filename}.xml`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};

const BulkExportIofXml = () => {
  const {record: event} = useRecordContext();
  const {selected} = useListContext();
  const [exportXml, {loading}] = useLazyQuery<{exportSubEventsIofXml: string}>(EXPORT_SUBEVENTS_IOF_XML, {
    fetchPolicy: 'network-only'
  });

  const handleClick = async () => {
    const ids = selected.map((id) => Number(id)).filter((id) => Number.isInteger(id));
    if (ids.length === 0) {
      return;
    }

    try {
      const result = await exportXml({
        variables: {
          slug: event.slug,
          ids
        }
      });
      const xml = result.data?.exportSubEventsIofXml;
      if (!xml) {
        toast.error('Export returned no XML');
        return;
      }
      downloadXml(xml, `${event.slug}-iof-courses.xml`);
    } catch (error) {
      toast.error(error instanceof Error ? error.message : 'Export failed');
    }
  };

  return (
    <Button startIcon={<FileDownload />} variant="text" onClick={handleClick} disabled={loading}>
      {loading ? 'Exporting...' : 'IOF XML'}
    </Button>
  );
};

export default BulkExportIofXml;
